(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  const pendingKey = 'paper-trail:footer-ticket:pending';
  const initialize = root => {
    root.querySelectorAll('.footer-ticket-form').forEach(form => {
      if (form.dataset.ticketInitialized) return;
      form.dataset.ticketInitialized = 'true';
      form.addEventListener('submit', event => {
        if (event.defaultPrevented) return;
        try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch {}
      });
      const receipt = form.querySelector('[data-ticket-receipt]');
      if (!receipt) return;
      let pendingAt = 0;
      try {
        pendingAt = Number(sessionStorage.getItem(pendingKey));
        sessionStorage.removeItem(pendingKey);
      } catch {}
      const elapsed = Date.now() - pendingAt;
      if (!pendingAt || elapsed < 0 || elapsed > 15 * 60 * 1000 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const tear = () => {
        receipt.classList.add('is-tearing');
        receipt.addEventListener('animationend', event => {
          if (event.animationName === 'footer-ticket-tear-off') receipt.classList.remove('is-tearing');
        });
      };
      if (!('IntersectionObserver' in window)) { tear(); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          observer.disconnect();
          tear();
        }
      }, { threshold: .2 });
      observer.observe(receipt);
      window.addEventListener('pagehide', () => {
        observer.disconnect();
        receipt.classList.remove('is-tearing');
      }, { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('pt-audience-collection')) return;
  const groups = ['type', 'category', 'drop', 'colour', 'size'];
  const normalise = value => value.trim().toLowerCase();
  class AudienceCollection extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const eventOptions = { signal: this.abort.signal };
      this.form = this.querySelector('[data-audience-form]');
      this.grid = this.querySelector('[data-audience-grid]');
      this.dialog = this.querySelector('[data-audience-dialog]');
      this.launcher = this.querySelector('[data-audience-open]');
      if (!this.form || !this.grid || !this.dialog || !this.launcher) return;
      this.sort = this.form.querySelector('select');
      this.search = this.querySelector('[data-audience-search]');
      this.query = '';
      this.items = [...this.querySelectorAll('[data-audience-item]')].map((node, index) => ({ node, index, title: node.dataset.title || node.textContent.trim(), category: [normalise(node.dataset.category || '')].filter(Boolean), drop: [normalise(node.dataset.drop || '')].filter(Boolean), price: Number(node.dataset.price), date: Number(node.dataset.date) || 0, type: [normalise(node.dataset.type)].filter(Boolean), colour: node.dataset.colour.split('|').map(normalise).filter(Boolean), size: node.dataset.size.split('|').map(normalise).filter(Boolean) }));
      this.options = {};
      for (const group of groups) {
        this.form.querySelector('[data-audience-options="' + group + '"]').replaceChildren();
        const labels = new Map();
        this.items.forEach(item => item[group].forEach(value => {
          let label = value;
          if (['type', 'category', 'drop'].includes(group)) label = item.node.dataset[group + 'Label'];
          else if (group === 'size') label = item.node.dataset.size.split('|').find(x => normalise(x) === value) || value;
          else label = value === 'black' ? this.dataset.blackLabel : item.node.dataset.colour.split('|').find(x => normalise(x) === value) || value;
          if (!labels.has(value)) labels.set(value, label);
        }));
        this.options[group] = [...labels].map(([value, label]) => {
          const row = document.createElement('label');
          row.className = 'audience-filter-option';
          const input = document.createElement('input');
          input.type = 'checkbox'; input.name = 'pt_' + group; input.value = value;
          const text = document.createElement('span'); text.textContent = label;
          const count = document.createElement('small'); count.setAttribute('aria-hidden', 'true');
          row.append(input);
          if (group === 'colour' && value === 'black') { const dot = document.createElement('span'); dot.className = 'audience-colour-dot'; dot.setAttribute('aria-hidden', 'true'); row.append(dot); }
          row.append(text, count);
          this.form.querySelector('[data-audience-options="' + group + '"]').append(row);
          return { input, count, value };
        });
      }
      this.querySelector('[data-audience-size-empty]').hidden = this.options.size.length > 0;
      const dated = this.items.length > 0 && this.items.every(item => item.date > 0);
      this.sort.querySelectorAll('option[value="newest"],option[value="oldest"]').forEach(option => { option.disabled = !dated; });
      this.querySelector('[data-audience-date-pending]').hidden = dated;
      this.restoreFromUrl();
      this.form.hidden = false;
      this.launcher.hidden = false;
      this.media = matchMedia('(max-width:900px)');
      this.relocate = () => {
        if (this.dialog.open) this.dialog.close();
        this.querySelector(this.media.matches ? '[data-audience-mobile-host]' : '[data-audience-desktop-host]').append(this.form);
      };
      this.media.addEventListener('change', this.relocate, eventOptions);
      this.relocate();
      this.launcher.addEventListener('click', () => { this.dialog.showModal(); document.body.classList.add('audience-filters-open'); }, eventOptions);
      this.dialog.addEventListener('close', () => { document.body.classList.remove('audience-filters-open'); }, eventOptions);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } }, eventOptions);
      this.querySelectorAll('[data-audience-close],[data-audience-done]').forEach(button => button.addEventListener('click', () => { this.dialog.close(); this.launcher.focus(); }, eventOptions));
      this.querySelectorAll('[data-audience-reset]').forEach(button => button.addEventListener('click', () => { this.form.reset(); this.query = ''; if (this.search) this.search.value = ''; this.apply(true); }, eventOptions));
      this.search?.addEventListener('input', () => { this.query = normalise(this.search.value); this.apply(true); }, eventOptions);
      this.querySelector('[data-audience-search-form]')?.addEventListener('submit', event => { event.preventDefault(); this.query = normalise(this.search.value); this.apply(true); }, eventOptions);
      this.form.addEventListener('change', () => this.apply(true), eventOptions);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.apply(true); }, eventOptions);
      window.addEventListener('popstate', () => { this.restoreFromUrl(); this.apply(false); }, eventOptions);
      this.apply(false);
    }
    selected() {
      return Object.fromEntries(groups.map(group => [group, this.options[group].filter(option => option.input.checked).map(option => option.value)]));
    }
    matches(item, selected, ignored) {
      return (!this.query || this.query.split(/\s+/).every(term => normalise(item.title).includes(term))) && groups.every(group => group === ignored || !selected[group].length || selected[group].some(value => item[group].includes(value)));
    }
    orderedItems() {
      return [...this.items].sort((a, b) => {
        let difference = 0;
        if (this.sort.value === 'price-ascending') difference = a.price - b.price;
        else if (this.sort.value === 'price-descending') difference = b.price - a.price;
        else if (this.sort.value === 'newest') difference = b.date - a.date;
        else if (this.sort.value === 'oldest') difference = a.date - b.date;
        else if (this.sort.value === 'title-ascending') difference = a.title.localeCompare(b.title, undefined, { numeric: true, sensitivity: 'base' });
        else if (this.sort.value === 'title-descending') difference = b.title.localeCompare(a.title, undefined, { numeric: true, sensitivity: 'base' });
        return difference || a.index - b.index;
      });
    }
    apply(updateUrl) {
      const selected = this.selected();
      let visible = 0;
      this.orderedItems().forEach(item => { item.node.hidden = !this.matches(item, selected); if (!item.node.hidden) visible += 1; this.grid.append(item.node); });
      this.querySelector('[data-audience-count]').textContent = (visible === 1 ? this.dataset.countSingular : this.dataset.countPlural).replace('__COUNT__', visible);
      this.querySelector('[data-audience-empty]').hidden = visible > 0;
      const active = groups.reduce((sum, group) => sum + selected[group].length, 0);
      this.querySelector('[data-audience-active]').textContent = active ? '(' + active + ')' : '';
      for (const group of groups) this.options[group].forEach(option => { option.count.textContent = this.items.filter(item => item[group].includes(option.value) && this.matches(item, selected, group)).length; });
      if (updateUrl) {
        const url = new URL(location.href);
        for (const group of groups) { url.searchParams.delete('pt_' + group); selected[group].forEach(value => url.searchParams.append('pt_' + group, value)); }
        if (this.sort.value === 'featured') url.searchParams.delete('pt_sort'); else url.searchParams.set('pt_sort', this.sort.value);
        if (this.query) url.searchParams.set('q', this.query); else url.searchParams.delete('q');
        history.replaceState(null, '', url);
      }
      const activeUrl = new URL(location.href);
      this.querySelectorAll('[data-audience-pagination] a').forEach(link => {
        const pageUrl = new URL(link.href, location.href);
        for (const key of ['view', 'q', ...groups.map(group => 'pt_' + group), 'pt_sort']) {
          pageUrl.searchParams.delete(key);
          activeUrl.searchParams.getAll(key).forEach(value => pageUrl.searchParams.append(key, value));
        }
        link.href = pageUrl.href;
      });
    }
    restoreFromUrl() {
      const params = new URL(location.href).searchParams;
      for (const group of groups) this.options[group].forEach(option => { option.input.checked = params.getAll('pt_' + group).map(normalise).includes(option.value); });
      this.query = normalise(params.get('q') || '');
      if (this.search) this.search.value = this.query;
      const requestedSort = params.get('pt_sort');
      this.sort.value = [...this.sort.options].some(option => option.value === requestedSort && !option.disabled) ? requestedSort : 'featured';
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('audience-filters-open');
      this.ready = false;
    }
  }
  customElements.define('pt-audience-collection', AudienceCollection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pt-drop-countdown')) {
  customElements.define('pt-drop-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this.dataset.dropDate || '');
      if (!match) return;
      const [, year, month, day] = match.map(Number);
      const target = new Date(year, month - 1, day, 0, 0, 0, 0);
      if (target.getFullYear() !== year || target.getMonth() !== month - 1 || target.getDate() !== day) return;
      this.target = target.getTime();
      this.clock = this.querySelector('[data-countdown-clock]');
      this.fallback = this.querySelector('[data-countdown-fallback]');
      this.ended = this.querySelector('[data-countdown-ended]');
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-countdown-' + unit + ']'));
      if (!this.clock || !this.fallback || !this.ended || this.units.some(unit => !unit)) return;
      this.tick = () => {
        const seconds = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        this.units.forEach((unit, index) => {
          const text = String(values[index]).padStart(2, '0');
          if (unit.textContent !== text) unit.textContent = text;
        });
        this.fallback.hidden = true;
        this.clock.hidden = seconds === 0;
        this.ended.hidden = seconds !== 0;
        if (seconds === 0) this.stop();
        return seconds > 0;
      };
      if (this.tick()) this.interval = window.setInterval(this.tick, 1000);
    }
    stop() {
      window.clearInterval(this.interval);
      this.interval = undefined;
    }
    disconnectedCallback() {
      this.stop();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-designs"]) return;
  try {
    
(() => {
  if (customElements.get('pt-audience-collection')) return;
  const groups = ['type', 'category', 'drop', 'colour', 'size'];
  const normalise = value => value.trim().toLowerCase();
  class AudienceCollection extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const eventOptions = { signal: this.abort.signal };
      this.form = this.querySelector('[data-audience-form]');
      this.grid = this.querySelector('[data-audience-grid]');
      this.dialog = this.querySelector('[data-audience-dialog]');
      this.launcher = this.querySelector('[data-audience-open]');
      if (!this.form || !this.grid || !this.dialog || !this.launcher) return;
      this.sort = this.form.querySelector('select');
      this.search = this.querySelector('[data-audience-search]');
      this.query = '';
      this.items = [...this.querySelectorAll('[data-audience-item]')].map((node, index) => ({ node, index, title: node.dataset.title || node.textContent.trim(), category: [normalise(node.dataset.category || '')].filter(Boolean), drop: [normalise(node.dataset.drop || '')].filter(Boolean), price: Number(node.dataset.price), date: Number(node.dataset.date) || 0, type: [normalise(node.dataset.type)].filter(Boolean), colour: node.dataset.colour.split('|').map(normalise).filter(Boolean), size: node.dataset.size.split('|').map(normalise).filter(Boolean) }));
      this.options = {};
      for (const group of groups) {
        this.form.querySelector('[data-audience-options="' + group + '"]').replaceChildren();
        const labels = new Map();
        this.items.forEach(item => item[group].forEach(value => {
          let label = value;
          if (['type', 'category', 'drop'].includes(group)) label = item.node.dataset[group + 'Label'];
          else if (group === 'size') label = item.node.dataset.size.split('|').find(x => normalise(x) === value) || value;
          else label = value === 'black' ? this.dataset.blackLabel : item.node.dataset.colour.split('|').find(x => normalise(x) === value) || value;
          if (!labels.has(value)) labels.set(value, label);
        }));
        this.options[group] = [...labels].map(([value, label]) => {
          const row = document.createElement('label');
          row.className = 'audience-filter-option';
          const input = document.createElement('input');
          input.type = 'checkbox'; input.name = 'pt_' + group; input.value = value;
          const text = document.createElement('span'); text.textContent = label;
          const count = document.createElement('small'); count.setAttribute('aria-hidden', 'true');
          row.append(input);
          if (group === 'colour' && value === 'black') { const dot = document.createElement('span'); dot.className = 'audience-colour-dot'; dot.setAttribute('aria-hidden', 'true'); row.append(dot); }
          row.append(text, count);
          this.form.querySelector('[data-audience-options="' + group + '"]').append(row);
          return { input, count, value };
        });
      }
      this.querySelector('[data-audience-size-empty]').hidden = this.options.size.length > 0;
      const dated = this.items.length > 0 && this.items.every(item => item.date > 0);
      this.sort.querySelectorAll('option[value="newest"],option[value="oldest"]').forEach(option => { option.disabled = !dated; });
      this.querySelector('[data-audience-date-pending]').hidden = dated;
      this.restoreFromUrl();
      this.form.hidden = false;
      this.launcher.hidden = false;
      this.media = matchMedia('(max-width:900px)');
      this.relocate = () => {
        if (this.dialog.open) this.dialog.close();
        this.querySelector(this.media.matches ? '[data-audience-mobile-host]' : '[data-audience-desktop-host]').append(this.form);
      };
      this.media.addEventListener('change', this.relocate, eventOptions);
      this.relocate();
      this.launcher.addEventListener('click', () => { this.dialog.showModal(); document.body.classList.add('audience-filters-open'); }, eventOptions);
      this.dialog.addEventListener('close', () => { document.body.classList.remove('audience-filters-open'); }, eventOptions);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } }, eventOptions);
      this.querySelectorAll('[data-audience-close],[data-audience-done]').forEach(button => button.addEventListener('click', () => { this.dialog.close(); this.launcher.focus(); }, eventOptions));
      this.querySelectorAll('[data-audience-reset]').forEach(button => button.addEventListener('click', () => { this.form.reset(); this.query = ''; if (this.search) this.search.value = ''; this.apply(true); }, eventOptions));
      this.search?.addEventListener('input', () => { this.query = normalise(this.search.value); this.apply(true); }, eventOptions);
      this.querySelector('[data-audience-search-form]')?.addEventListener('submit', event => { event.preventDefault(); this.query = normalise(this.search.value); this.apply(true); }, eventOptions);
      this.form.addEventListener('change', () => this.apply(true), eventOptions);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.apply(true); }, eventOptions);
      window.addEventListener('popstate', () => { this.restoreFromUrl(); this.apply(false); }, eventOptions);
      this.apply(false);
    }
    selected() {
      return Object.fromEntries(groups.map(group => [group, this.options[group].filter(option => option.input.checked).map(option => option.value)]));
    }
    matchesItem(item, selected, ignored) {
      return (!this.query || this.query.split(/\s+/).every(term => normalise(item.title).includes(term))) && groups.every(group => group === ignored || !selected[group].length || selected[group].some(value => item[group].includes(value)));
    }
    orderedItems() {
      return [...this.items].sort((a, b) => {
        let difference = 0;
        if (this.sort.value === 'price-ascending') difference = a.price - b.price;
        else if (this.sort.value === 'price-descending') difference = b.price - a.price;
        else if (this.sort.value === 'newest') difference = b.date - a.date;
        else if (this.sort.value === 'oldest') difference = a.date - b.date;
        else if (this.sort.value === 'title-ascending') difference = a.title.localeCompare(b.title, undefined, { numeric: true, sensitivity: 'base' });
        else if (this.sort.value === 'title-descending') difference = b.title.localeCompare(a.title, undefined, { numeric: true, sensitivity: 'base' });
        return difference || a.index - b.index;
      });
    }
    apply(updateUrl) {
      const selected = this.selected();
      let visible = 0;
      this.orderedItems().forEach(item => { item.node.hidden = !this.matchesItem(item, selected); if (!item.node.hidden) visible += 1; this.grid.append(item.node); });
      this.querySelector('[data-audience-count]').textContent = (visible === 1 ? this.dataset.countSingular : this.dataset.countPlural).replace('__COUNT__', visible);
      this.querySelector('[data-audience-empty]').hidden = visible > 0;
      const active = groups.reduce((sum, group) => sum + selected[group].length, 0);
      this.querySelector('[data-audience-active]').textContent = active ? '(' + active + ')' : '';
      for (const group of groups) this.options[group].forEach(option => { option.count.textContent = this.items.filter(item => item[group].includes(option.value) && this.matchesItem(item, selected, group)).length; });
      if (updateUrl) {
        const url = new URL(location.href);
        for (const group of groups) { url.searchParams.delete('pt_' + group); selected[group].forEach(value => url.searchParams.append('pt_' + group, value)); }
        if (this.sort.value === 'featured') url.searchParams.delete('pt_sort'); else url.searchParams.set('pt_sort', this.sort.value);
        if (this.query) url.searchParams.set('q', this.query); else url.searchParams.delete('q');
        history.replaceState(null, '', url);
      }
      const activeUrl = new URL(location.href);
      this.querySelectorAll('[data-audience-pagination] a').forEach(link => {
        const pageUrl = new URL(link.href, location.href);
        for (const key of ['view', 'q', ...groups.map(group => 'pt_' + group), 'pt_sort']) {
          pageUrl.searchParams.delete(key);
          activeUrl.searchParams.getAll(key).forEach(value => pageUrl.searchParams.append(key, value));
        }
        link.href = pageUrl.href;
      });
    }
    restoreFromUrl() {
      const params = new URL(location.href).searchParams;
      for (const group of groups) this.options[group].forEach(option => { option.input.checked = params.getAll('pt_' + group).map(normalise).includes(option.value); });
      this.query = normalise(params.get('q') || '');
      if (this.search) this.search.value = this.query;
      const requestedSort = params.get('pt_sort');
      this.sort.value = [...this.sort.options].some(option => option.value === requestedSort && !option.disabled) ? requestedSort : 'featured';
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('audience-filters-open');
      this.ready = false;
    }
  }
  customElements.define('pt-audience-collection', AudienceCollection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('change', event => {
  if (!event.target.matches('[data-native-variant]')) return;
  const option = event.target.selectedOptions[0];
  const section = event.target.closest('[data-product-section]');
  if (!option || !section) return;
  section.querySelector('[data-variant-price]').textContent = option.dataset.price;
  const compare = section.querySelector('[data-variant-compare]');
  compare.textContent = option.dataset.compare;
  compare.hidden = !option.dataset.compare;
  const quantity = section.querySelector('[data-variant-quantity]');
  quantity.min = option.dataset.min || '1';
  quantity.step = option.dataset.step || '1';
  if (option.dataset.max) quantity.max = option.dataset.max;
  else quantity.removeAttribute('max');
  quantity.value = quantity.min;
  const button = section.querySelector('[data-add-button]');
  button.disabled = option.disabled;
  if (!option.disabled) button.textContent = button.dataset.addLabel;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
});

  } catch(e) { console.error(e); }
})();
})();
